<template>
  <div class="flex justify-center items-center h-screen">
    <div class="text-center">
      <img class="h-40 mx-auto mb-6" :src="`/img/${noProduct ? 'clouds' : 'not_found'}.png`" alt="" />
      <h1 class="text-2xl font-bold text-dark mb-2">{{ noProduct ? t('nothingHere') : error?.statusCode === 404 ? t('404') : t('error') }}</h1>
      <p class="font-semibold text-mediumgray mb-6">{{ noProduct ? t('noProduct') : error?.statusCode === 404 ? t('404text') : t('errortext') }}</p>
      <ButtonMain :type="1" :text="t('back')" class="mx-auto" @click="handleError" />
    </div>
  </div>
</template>
<script setup lang="ts">
  const { t } = useI18n()
  const error = useError()

  const noProduct = computed(() => error.message === 'no-product')
  function handleError() {
    clearError()
    reloadNuxtApp()
  }
</script>
<i18n>
{
  "pt": {
    "back": "Voltar à página inicial",
    "404": "Página não encontrada",
    "404text": "A página a que tentou aceder não existe ou foi removida",
    "error": "Ocorreu um erro",
    "errortext": "Houve um problema a carregar a página",
    "nothingHere": "Não há nada aqui.",
    "noProduct": "Houve um problema ao carregar o produto."
  },
  "en": {
    "back": "Back to home page",
    "404": "Page not found",
    "404text": "The page you are trying to access does not exist or has been removed",
    "error": "An error occurred",
    "errortext": "There was a problem loading the page",
    "nothingHere": "There's nothing here.",
    "noProduct": "There was a problem loading the product."
  },
  "es": {
    "back": "Volver a la página de inicio",
    "404": "Página no encontrada",
    "404text": "La página a la que intenta acceder no existe o ha sido eliminada",
    "error": "Se ha producido un error",
    "errortext": "Hubo un problema al cargar la página",
    "nothingHere": "No hay nada aquí.",
    "noProduct": "Hubo un problema al cargar el producto."
  },
  "fr": {
    "back": "Retour à la page d'accueil",
    "404": "Page non trouvée",
    "404text": "La page que vous essayez d'accéder n'existe pas ou a été supprimée",
    "error": "Une erreur s'est produite",
    "errortext": "Il y a eu un problème lors du chargement de la page",
    "nothingHere": "Il n'y a rien ici.",
    "noProduct": "Il y a eu un problème lors du chargement du produit."
  }
}
</i18n>
